export enum ReRunModalType {
  ONCO_EMR = "onco-emr",
  CMM = "cmm",
}
